import React from "react";
import { postRequest } from "./QuoteApiService";

export const getAddressesTypeahead = (rec) => {
  return new Promise((resolve, reject) => {
    try {
      // do an SDK, DB call or API endpoint axios call here and return the promise.
      postRequest('GetAddressesTypeahead/', rec)
      .then((res) => {
        console.log("GetAddressesTypeahead > axios res=", res);
        //const persons = res.data;
        resolve(res.data);
      })
      .catch((err) => {
        console.log("GetAddressesTypeahead > axios err=", err);
        reject("Error in getAllUsers axios!");
      });
    } catch (error) {
      console.error("in services > GetAddressesTypeahead, Err===", error);
      //reject(SYSTEM_ERROR);
    }
  });
  
}
